import * as Immutable from "immutable";
import { BaseEntity } from "../../baseEntity";

export class ConfHeaderValue extends BaseEntity {
}